export default '8.4.1';



//////////////////
// WEBPACK FOOTER
// ../~/mmenu-js/dist/_version.js
// module id = 53
// module chunks = 0